/** @format */

import React from "react";
import {
  checkBookMark,
  createBookMark,
  deleteBookMark,
} from "./helpers/bookmark";
import { BookmarkIcon } from "@heroicons/react/outline";

export default function BookmarkButton(props) {
  const { id, cover_image, name } = props;
	const [isBookmarked, setBookmarked] = React.useState(checkBookMark(id));

	const handelBookMark = () => {
		if (!isBookmarked) {
			createBookMark(name, cover_image, id);
			setBookmarked(true);
		} else {
			setBookmarked(false);
			deleteBookMark(id);
		}
	};

  return (
    <div onClick={handelBookMark} className="cursor-pointer w-full">
      {checkBookMark(id) ? (
        <i className=" fa fa-bookmark text-gray-500 fa-lg mt-2 h-4 w-5" />
      ) : (
        <BookmarkIcon className="text-gray-500 inline-block h-5 w-5" />
      )}
      {props.title}
    </div>
  );
}
